//@flow
import React from 'react';
import './styles.scss';
import Dotdotdot from 'react-dotdotdot';
import RupeePinkIcon from 'assets/images/rupee-icon-pink.png';
import { useViewport } from 'components/templates/viewportProvider';
import DollarPinkIcon from 'assets/images/Dollar-Icon.png';
type Props = {
  data: RestaurantMenu,
  onClick: void,
};
export const DiningMenuCard = (props: Props) => {
  const { data, onClick } = props;
  const { isMobile } = useViewport();
  return (
    <div className={'menu-row'}>
      <div
        className={'item-name-price-row'}
        onClick={() => (isMobile ? {} : onClick(data))}
      >
        <h3 className={'item-name'}>{data.name}</h3>
        <div className={'rupee-icon-container'}>
          {data.price && data.currencyType === 'Rupee' && (
            <img src={RupeePinkIcon} alt="Rupees" className={'currency-icon'} />
          )}
          {data.price && data.currencyType !== 'Rupee' && (
            <img
              src={DollarPinkIcon}
              alt="Rupees"
              className={'currency-icon'}
            />
          )}
          <span>{data.price}</span>
        </div>
      </div>
      {!isMobile ? (
        <Dotdotdot clamp={4} tagName={'p'}>
          {data.description}
        </Dotdotdot>
      ) : (
        <Dotdotdot clamp={4} tagName={'p'}>
          {data.item_mobile_description}
        </Dotdotdot>
      )}
    </div>
  );
};
